import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const VendorLedgerPage = lazy(() => import("@/pages/reports.ledger-vendor.page"));

export const Route = createFileRoute("/reports/ledger-vendor")({
  component: VendorLedgerPage,
});
